import { observer } from 'mobx-react';

import styles from './CompositePrice.module.scss';

import { Currency, ServiceStatus } from 'chaika-enums';
import { Nullable } from 'chaika-common-types';

import { Money } from '@store/models/Money';

import { ServiceSelect } from '@components/ModelSelect/ServiceSelect';
import { OptionType } from '@components/Select';
import { Icon, IconType } from '@components/Icon';

interface Props {
    serviceId: string;
    isClearable: boolean;
    dataTest: string;
    disabled?: boolean;
    price: number;
    currency: Currency;
    onItemChange(params: Nullable<OptionType>): void;
    onDelete(): void;
}

export const CompositePrice = observer(
    ({ serviceId, isClearable, disabled, onItemChange, dataTest, onDelete, price, currency }: Props) => {
        return (
            <div className={styles.root}>
                <ServiceSelect
                    serviceQuery={{ statuses: [ServiceStatus.Active] }}
                    isClearable={isClearable}
                    disabled={disabled}
                    dataTest={dataTest}
                    onChange={(params, name) => onItemChange(params)}
                    serviceId={serviceId}
                />
                <div className={styles.price}>{new Money(price, currency).toString({ withoutKopecks: true })}</div>
                <div
                    className={styles.delete}
                    onClick={onDelete}
                >
                    <Icon type={IconType.TRASH_REDESIGN} />
                </div>
            </div>
        );
    },
);
